/**应用组件路由 */
export default [
    {
        name:'assembly',
        path:'assembly',
        meta: { title: '应用组件' },
        component: ()=>import('@/pages/assembly/index.vue'),
        children: [
            {
                name: 'assembly',
                path: 'wxpacket',
                meta: { title: '微信关注扫码领红包' },
                component: ()=>import('@/pages/assembly/wxpacket.vue')
            },
            {
                name: 'assembly',
                path: 'integral',
                meta: { title: '积分兑换' },
                component: ()=>import('@/pages/assembly/integral.vue')
            },
            {
                name: 'assembly',
                path: 'turntable',
                meta: { title: '大转盘' },
                component: ()=>import('@/pages/assembly/turntable.vue')
            },
        ]
    }
]